import { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";
import LocalizationContext from "../../../providers/localization/LocalizationContext";
import LayoutComponent from "../../../layouts/layoutComponent/LayoutComponent";
import CreateQrsComponent from "../list/form/create_qrs.component";
import routes from "../../../routes/Routes";
import { useForm } from "react-hook-form";

const CreateQrPage: FC<{}> = () => {
    const { i18n } = useContext(LocalizationContext);
    const navigate = useNavigate();

    const handleOnCreated = () => {
        navigate(routes.qr_list.relativePath);
    };

    return (
        <LayoutComponent title={i18n("Crear QRs")}>
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="mb-0">{i18n("Crear QRs en Masa")}</h4>
                            </div>
                            <div className="card-body">
                                <CreateQrsComponent onCreated={handleOnCreated} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutComponent>
    );
};

export default CreateQrPage;